import { render, staticRenderFns } from "./dialog-view-sharing-settings.vue?vue&type=template&id=50e86a36&scoped=true"
import script from "./dialog-view-sharing-settings.vue?vue&type=script&lang=js"
export * from "./dialog-view-sharing-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e86a36",
  null
  
)

export default component.exports